<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">The Things We Hide at Home</span></p>
<p class="p0">By Nem Rowan</p>
<p class="p2"><a id="a3"></a><a href="#/005#a18">Chapter 1</a></p>
<p class="p2"><span href="#/006#a19" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p2"><span href="#/007#a20" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p2"><span href="#/008#a21" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p2"><span href="#/009#a22" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p2"><span href="#/010#a23" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p2"><span href="#/011#a24" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p2"><span href="#/012#a25" title="Link target outside of Sample">Chapter 8</span></p>
<p class="p2"><span href="#/013#a26" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p2"><span href="#/014#a27" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p2"><span href="#/015#a28" title="Link target outside of Sample">Chapter 11</span></p>
<p class="p2"><span href="#/016#a29" title="Link target outside of Sample">Chapter 12</span></p>
<p class="p2"><span href="#/017#a30" title="Link target outside of Sample">Epilogue</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?fa0d4824